import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  QueryList,
  signal,
  ViewChildren,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-badge-list',
  imports: [TranslateModule],
  templateUrl: './badge-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeListComponent {
  @ViewChildren('chips')
  public chips: QueryList<ElementRef>;

  public items = input.required<string[]>();
  public showMoreText = input<string>(this.translate.instant('Core_ShowMore'));
  public threshold = input<number>(5);

  public shouldShowMore = signal(false);

  constructor(private translate: TranslateService) {}

  public expand() {
    this.shouldShowMore.set(true);

    setTimeout(() => {
      this.chips.last?.nativeElement.focus();
    });
  }
}
